var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1171275921(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#FA5A7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6498 22.55C24.3854 22.55 22.5498 24.3857 22.5498 26.65V55.35C22.5498 57.6143 24.3854 59.45 26.6498 59.45H55.3498C57.6142 59.45 59.4498 57.6143 59.4498 55.35V26.65C59.4498 24.3857 57.6142 22.55 55.3498 22.55H26.6498ZM32.7998 43.05C32.7998 41.9178 31.882 41 30.7498 41C29.6176 41 28.6998 41.9178 28.6998 43.05V51.25C28.6998 52.3822 29.6176 53.3 30.7498 53.3C31.882 53.3 32.7998 52.3822 32.7998 51.25V43.05ZM40.9998 34.85C42.132 34.85 43.0498 35.7678 43.0498 36.9V51.25C43.0498 52.3822 42.132 53.3 40.9998 53.3C39.8676 53.3 38.9498 52.3822 38.9498 51.25V36.9C38.9498 35.7678 39.8676 34.85 40.9998 34.85ZM53.2998 30.75C53.2998 29.6178 52.382 28.7 51.2498 28.7C50.1176 28.7 49.1998 29.6178 49.1998 30.75V51.25C49.1998 52.3822 50.1176 53.3 51.2498 53.3C52.382 53.3 53.2998 52.3822 53.2998 51.25V30.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275921);
export default __webpack_public_path__ + "static/media/Group 1171275921.878f25117e1f91c9964375d02f97fa3c.svg";
export { ForwardRef as ReactComponent };